export default __webpack_public_path__ + "static/media/Group2131-tata-neu.cf53027a.png";